import { MainContainer, Tab } from '@/components/atoms'
import {
  CalculateDirectRequest,
  CalculateSubRequest,
} from '@/components/organisms'
import { Layout } from '@/components/templates'
import { useGetConfig, useGetFeeConfig } from '@/hooks'
import { TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { formatEther, formatGwei } from 'viem'
import { useChainId, useGasPrice } from 'wagmi'

export const Calculator = () => {
  const [calcInitData, setCalcInitData] = useState({
    coordinatorGas: 90000,
    wrapperGas: 40000,
    averageVerificationGas: 92500,
    maxCallbackGasLimit: 0,
    gasPrice: 0,
    protocolFee: 0,
  })
  const [result, setResult] = useState(0)
  const [maxResult, setMaxResult] = useState(0)
  const chainId = useChainId()
  const {
    handleSubmit,
    register,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      callbackGas: 0,
      gasPrice: calcInitData.gasPrice,
    },
  })
  const { data: networkGasPrice } = useGasPrice({ chainId })
  const { data: vrfMaxCallbackGasLimit } = useGetConfig()
  const { data: vrfProtocolFee } = useGetFeeConfig()

  const onSubmitCallback = ({ result, maxResult }) => {
    result && setResult(result)
    maxResult && setMaxResult(maxResult)
  }

  const resetFormState = () => {
    reset()
    setValue('gasPrice', calcInitData.gasPrice)
    setResult(0)
    setMaxResult(0)
  }

  useEffect(() => {
    if (vrfProtocolFee) {
      const protocolFee = Number(formatEther(vrfProtocolFee * 1e12, 'wei'))

      setCalcInitData((prev) => ({ ...prev, protocolFee }))
    }
  }, [vrfProtocolFee])

  useEffect(() => {
    if (vrfMaxCallbackGasLimit) {
      setCalcInitData((prev) => ({
        ...prev,
        maxCallbackGasLimit: vrfMaxCallbackGasLimit,
      }))
    }
  }, [vrfMaxCallbackGasLimit])

  useEffect(() => {
    if (networkGasPrice) {
      const gasPriceInGwei = formatGwei(networkGasPrice, 'wei')

      setCalcInitData((prev) => ({
        ...prev,
        gasPrice: gasPriceInGwei,
      }))
      setValue('gasPrice', gasPriceInGwei)
    }
  }, [networkGasPrice, setValue])

  return (
    <Layout withBackButton>
      <MainContainer>
        <Tabs
          isLazy
          align="center"
          variant="unstyled"
          isFitted
          onChange={() => resetFormState()}
        >
          <TabList gap={4}>
            <Tab>Subscription</Tab>
            <Tab>Direct Request</Tab>
          </TabList>
          <TabPanels>
            <TabPanel p={[0, 4]}>
              <CalculateSubRequest
                callback={onSubmitCallback}
                handleSubmit={handleSubmit}
                register={register}
                result={result}
                maxResult={maxResult}
                setValue={setValue}
                calcInitData={calcInitData}
                errors={errors}
              />
            </TabPanel>
            <TabPanel p={[0, 4]}>
              <CalculateDirectRequest
                callback={onSubmitCallback}
                handleSubmit={handleSubmit}
                register={register}
                calcInitData={calcInitData}
                result={result}
                setValue={setValue}
                errors={errors}
              />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </MainContainer>
    </Layout>
  )
}
